import React from 'react'
import { Mail, MapPin, Instagram, Facebook, Youtube } from 'lucide-react'

const APP_STORE_URL = 'https://apps.apple.com/za/app/zoelive-prayer'
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.zoelive.prayer'

const Footer = () => {
  const currentYear = new Date().getFullYear()

  const footerLinks = {
    product: [
      { label: 'Home', href: '#' },
      { label: 'How It Works', href: '#how-it-works' },
      { label: 'Pricing', href: '#pricing' },
      { label: 'Devotion Library', href: '#library' },
      { label: 'Prayer Pods', href: '#pods' },
      { label: 'Premium Features', href: '#premium' },
    ],
    resources: [
      { label: 'Help Centre', href: '#' },
      { label: 'FAQs', href: '#faq' },
      { label: 'Blog', href: '#' },
      { label: 'Privacy Policy', href: '#privacy' },
      { label: 'Terms of Service', href: '#terms' },
      { label: 'Contact Support', href: '#contact' },
    ],
  }

  const socialLinks = [
    { icon: Instagram, href: 'https://instagram.com/zoeliveprayer', label: 'Instagram' },
    { icon: Facebook, href: 'https://facebook.com/zoeliveprayer', label: 'Facebook' },
    { icon: Youtube, href: 'https://youtube.com/@zoeliveprayer', label: 'YouTube' },
  ]

  return (
    <footer className="bg-heading-dark text-white/80">
      <div className="container-custom py-16">
        <div className="grid md:grid-cols-4 gap-8 mb-12">
          {/* Column 1: Company Info */}
          <div>
            <h3 className="text-2xl font-bold text-white mb-4">ZoeLive Prayer</h3>
            <p className="text-sm mb-4 leading-relaxed">
              Live Your Faith.
              <br />
              Not Your Feeds.
            </p>
            <div className="space-y-2 text-sm">
              <div className="flex items-center gap-2">
                <Mail size={16} />
                <a href="mailto:hello@zoeliveprayer.co.za" className="hover:text-white transition-colors">
                  hello@zoeliveprayer.co.za
                </a>
              </div>
              <div className="flex items-center gap-2">
                <MapPin size={16} />
                <span>Based in Cape Town, South Africa</span>
              </div>
            </div>

            {/* Social Media */}
            <div className="flex gap-4 mt-6">
              {socialLinks.map((social, index) => {
                const Icon = social.icon
                return (
                  <a
                    key={index}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-zoe-primary transition-all"
                    aria-label={social.label}
                  >
                    <Icon size={20} />
                  </a>
                )
              })}
            </div>
          </div>

          {/* Column 2: Product */}
          <div>
            <h4 className="font-semibold text-white mb-4">Product</h4>
            <ul className="space-y-2 text-sm">
              {footerLinks.product.map((link, index) => (
                <li key={index}>
                  <a href={link.href} className="hover:text-white transition-colors">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3: Resources */}
          <div>
            <h4 className="font-semibold text-white mb-4">Resources</h4>
            <ul className="space-y-2 text-sm">
              {footerLinks.resources.map((link, index) => (
                <li key={index}>
                  <a href={link.href} className="hover:text-white transition-colors">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 4: Download */}
          <div>
            <h4 className="font-semibold text-white mb-4">Get the App</h4>
            <div className="space-y-3">
              <a
                href={APP_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="block bg-black text-white px-4 py-3 rounded-lg text-sm font-semibold hover:bg-gray-800 transition-all"
              >
                Download on the App Store
              </a>
              <a
                href={PLAY_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="block bg-black text-white px-4 py-3 rounded-lg text-sm font-semibold hover:bg-gray-800 transition-all"
              >
                Get it on Google Play
              </a>
              <p className="text-xs mt-4">Works on iOS 16+ and Android 8+</p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 text-center text-sm">
          <p>
            &copy; {currentYear} ZoeLive Prayer (Pty) Ltd. All rights reserved. | Made with love for the global Church
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
